import { render, staticRenderFns } from "./LlpBidsTable.vue?vue&type=template&id=0c8b9938&scoped=true"
import script from "./LlpBidsTable.vue?vue&type=script&lang=js"
export * from "./LlpBidsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8b9938",
  null
  
)

export default component.exports